import { ReactNode } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { PATHS } from "@router/paths";

import Footer from "@components/layoutElements/Footer/Footer";

import "./NotFoundLayout.scss";

interface ILayout {
  children?: ReactNode;
  className?: string;
}

const NotFoundLayout = ({ children, className }: ILayout) => {
  const { t } = useTranslation("notFound");

  const navigate = useNavigate();
  const goToHome = () => navigate(PATHS.main.path);

  const classes = classNames("not-found-layout", className);

  return (
    <div className={classes}>
      <div className="navbar-part">
        <div className="header">
          <div className="app-navbar-container">
            <button onClick={goToHome}>
              <img src="/images/branding/skey-tix-logo.svg" alt="Skey Tix" className="navbar-logo" />
            </button>

            <button className="nav-links single" onClick={goToHome}>
              {t("return")}
            </button>
          </div>
        </div>
      </div>

      <div className="main-part">{children}</div>

      <div className="footer-part">
        <Footer />
      </div>
    </div>
  );
};

export default NotFoundLayout;
